import React, { useState, useEffect } from "react";
import { Button, Icon, Confirm, Card } from "semantic-ui-react";
import { Role, Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal } from "../../../Shared";
import { RoleForm } from "../../Roles/RoleForm";
import { PermissionsRole } from "../PermissionsRole/PermissionsRole";
import "./RoleItem.scss";
import { isAdmin , hasPermission, isMaster} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";
 
// tu Card inline
const roleController = new Role();
const permissionController = new Permission();

export function RoleItem(props) {
  const { role, onReload } = props;
  const { accessToken } = useAuth();
  const roleUser = useAuth().user.role;

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [permissionsByRole, setPermissionsByRole] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        if (roleUser) {
          const response = await permissionController.getPermissionsByRole(accessToken, roleUser._id, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [roleUser]);

  // Aquí mostramos directamente el Card editable
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>

    <div key={role._id} style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "0.5rem", background: "#fff" }}>
      <PermissionsRole
      role={role}
      roleUser={roleUser}
      permissionsByRole={permissionsByRole}
      t={t}
      onReload={onReload}
    />
    </div>
</div>
    
  );
}

